namespace $ {

	export class $shm_hitalama_vk_list extends $giper_baza_entity.with({

		Name: $giper_baza_atom_text,
		Groups: $giper_baza_list_link.to( ()=> $shm_hitalama_vk_group )

	}){

	}


}
